// Shared client-side CSV export. Two halves on purpose: buildCsv is a pure
// string builder so it can run under node for the assert script, and
// downloadCsv is the only part that touches the DOM.

const BOM = '﻿';

// Cells that start with one of these are read as a formula by Excel and by
// Sheets. The tables hold names taken from a customer org, so every such cell
// gets a leading single quote before it is quoted.
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

export type CsvCell = string | number | null | undefined;

export function escapeCsvCell(value: CsvCell): string {
  if (value === null || value === undefined) return '';
  let text = String(value);
  if (FORMULA_PREFIX.test(text)) text = `'${text}`;
  if (/[",\r\n]/.test(text)) text = `"${text.replace(/"/g, '""')}"`;
  return text;
}

/** RFC 4180 rows, CRLF line breaks, UTF-8 BOM so Excel reads the encoding. */
export function buildCsv(headers: string[], rows: CsvCell[][]): string {
  const lines = [headers, ...rows].map((row) => row.map(escapeCsvCell).join(','));
  return BOM + lines.join('\r\n') + '\r\n';
}

export function downloadCsv(fileName: string, headers: string[], rows: CsvCell[][]): void {
  const blob = new Blob([buildCsv(headers, rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Safari can abort the download when the URL is revoked in the same tick.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
